module.exports = __webpack_public_path__ + "static/smallpatio-893119fec21e1bb49607e1bf7a789b9b.jpeg";